import { IntlTFunc } from 'next-intl';

import {
  ProductFragment,
  SimpleProductFragmentDoc,
  SimpleProductFragment,
  getFragmentData
} from '@/fo/api/magento';

import { ProductsMindbox } from '../types';

import { utilMapConfigurableProductData } from './utilMapConfigurableProductData';
import { utilMapGroupedProductData } from './utilMapGroupedProductData';
import { utilMapSimpleProductData } from './utilMapSimpleProductData';

export const utilMapProductData = (
  product: ProductFragment,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox,
  options?: { preselectFirstInStock?: boolean }
) => {
  switch (product.__typename) {
    case 'ConfigurableProduct':
      return utilMapConfigurableProductData(
        product,
        t,
        mindboxProducts,
        options
      );
    case 'GroupedProduct':
      return utilMapGroupedProductData(product, t, mindboxProducts);
    case 'SimpleProduct':
      return utilMapSimpleProductData(
        getFragmentData(SimpleProductFragmentDoc, product),
        t,
        mindboxProducts
      );
    default:
      return utilMapSimpleProductData(
        product as SimpleProductFragment,
        t,
        mindboxProducts
      );
  }
};
